import { ChcekboxOption } from ".";

const data = [
  {
    name: "HMO",
    tooltip:
      "A Health Maintenance Organization (HMO) is a type of Medicare Advantage plan (Part C). With an HMO, you generally must get your care and services from doctors, other health care providers, and hospitals in Alignment Health Plan’s network.",
  },
  {
    name: "PPO",
    tooltip:
      "A Preferred Provider Organization (PPO) is a type of Medicare Advantage plan (Part C). With a PPO, you will often pay less if you choose in-network providers and facilities than choosing out-of-network providers and facilities for covered medical services.",
  },
  {
    name: "D-SNP",
    tooltip:
      "Alignment Health Plan offers Dual Special Needs Plans (D-SNPs) to those who have both Medicare and Medicaid eligibility. If you qualify, a D-SNP can help you get the health care you need with the providers you want at an affordable cost.",
  },
  {
    name: "C-SNP",
    tooltip:
      "Alignment Health Plan offers Chronic Condition Special Needs Plans (C-SNPs) to those with qualifying chronic health conditions, such as diabetes, heart conditions, and end-stage renal disease (ESRD). C-SNPs provide customized care to fit the unique health care needs those chronic conditions require.",
  },
  {
    name: "Veterans",
    tooltip:
      "Alignment Health Plan offers plans designed to meet the needs of those who proudly serve our country. These plans complement the Veterans Affairs (VA) health care coverage for those who served in active duty military and received an honorable discharge.",
  },
];

const PlanTypeCheckBox = ({
  filtersArray,
  setActuallFilters,
}: {
  filtersArray: string[];
  setActuallFilters: (arr: string[]) => void;
}) => {
  return (
    <div className="grid-x small-12 medium-6">
      <div className="cell small-12" style={{ padding: "24px 0 10px" }}>
        <h4 style={{ fontSize: "18px" }}>Plan Type</h4>
      </div>
      <div className="cell small-12 medium-6 large-6">
        <div className="grid-y">
          {data
            .filter((option) => option.name === "HMO" || option.name === "PPO")
            .map((option, index) => (
              <ChcekboxOption
                key={index}
                option={option}
                filtersArray={filtersArray}
                setActuallFilters={setActuallFilters}
              />
            ))}
        </div>
      </div>
      <div className="cell small-12 medium-6 large-6">
        <div className="grid-y">
          {data
            .filter((option) => option.name !== "HMO" && option.name !== "PPO")
            .map((option, index) => (
              <ChcekboxOption
                key={index}
                option={option}
                filtersArray={filtersArray}
                setActuallFilters={setActuallFilters}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default PlanTypeCheckBox;
